'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *  TimeRanges to string helper
 */

var TimeRanges = {
  toString: function toString(r) {
    var log = '',
        len = r.length;
    for (var i = 0; i < len; i++) {
      log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
    }
    return log;
  }
};

exports.default = TimeRanges;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/hls.js/src/utils/timeRanges.js
// module id = 118
// module chunks = 0